import * as React from 'react';

var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function SvgSwipeCard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.997 11c0-2.004.836-3.834 2-4.997.799-.8 3.664-2.333 4.997-3M12.995 9v1.5c0 .166-.2.7-1 1.5-1 1-2 1.998-1 2.998 1.112 1.111 2.5 0 3.999-1L17.993 12c.333-.333 1-1.494 1.999-3.998 1-2.504 1-5.003 1-5.003",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.792 11H5.34c-1.288 0-2.332 1.033-2.332 2.307v5.382c0 1.274 1.044 2.307 2.332 2.307h10.163c1.288 0 2.332-1.033 2.332-2.307v-5.382-1.203M17.82 17.996H3.01",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.994 2.998h6.997",
    stroke: "currentColor",
    strokeWidth: 1.5
  })));
}

export { SvgSwipeCard as ReactComponent };
